/**
 * Escapes characters that carry special meaning in a regular expression, so the value is
 * matched literally when passed to the RegExp constructor.
 * @param value - Text to escape
 * @returns The text with regular expression metacharacters escaped
 */
export const escapeRegExp = (value: string): string => value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
